import './public-path';
import fromEntries from 'object.fromentries';
fromEntries.shim();
import 'i18n-wrapper';
import 'shared';
import 'details';
